import { Button, styled } from '@mui/material'

export const StyledButton = styled(Button)(() => ({
  borderRadius: '2px',
  height: '32px',
  fontSize: '14px',
  fontWeight: 700,
  ':hover': { cursor: 'pointer' },
}))
